<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      User
    </button>
    <a-modal v-model="visible" title="Add a new user">
      <template slot="footer">
        <a-button key="clear" class="btn btn-light float-left" @click="handleClear">Clear Form</a-button>
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add User</a-button>
      </template>

      <a-form :form="form">
        <div class="row mb-0">
          <div class="col-md-6">
            <a-form-item label="First Name">
              <a-input
                placeholder="First name"
                v-decorator="['first_name', {rules: [{ required: true, message: 'Please input first name!' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Last Name">
              <a-input
                placeholder="Last name"
                v-decorator="['last_name', {rules: [{ required: true, message: 'Please input last name!' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Email">
              <a-input
                placeholder="Email"
                v-decorator="[
                  'email',
                  {
                    rules: [{
                      type: 'email', message: 'The input is not valid email!',
                    }, {
                      required: true, message: 'Please input an email!',
                    }]
                  }
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Phone">
              <a-input
                placeholder="Phone"
                v-decorator="['phone', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
                width="100%"
              >
              <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'country_code',
                    { initialValue: '91' }
                  ]"
                  style="width: 70px"
                >
                  <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                    <span class="text-bold">{{countryCode.name}}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Role">
              <a-select
                placeholder="Select role"
                optionFilterProp="children"
                style="width: 220px"
                :filterOption="false"
                v-decorator="['role', {rules: [{ required: true, message: 'Please select a role' },], initialValue: 'supervisor'}]"
              >
              <template v-for="role in userRoles">
                <a-select-option :key="role.value"
                :value="role.value">
                  {{ role.name }}
                </a-select-option>
              </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <a-form-item label="Password">
              <a-input-password
                v-decorator="[
                  'password',
                  {
                    rules: [{
                      required: true, message: 'Please input a password!',
                    }, {
                      validator: validateToNextPassword,
                    }],
                  }
                ]"
                type="password"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Confirm Password" has-feedback>
              <a-input-password
                v-decorator="[
                  'confirm_password',
                  {
                    rules: [{
                      required: true, message: 'Please confirm user password!',
                    }, {
                      validator: compareToFirstPassword,
                    }],
                  }
                ]"
                type="password"
                @blur="handleConfirmBlur"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { countryCodes } from '@/services/globaldata'
import { userRoles } from '../data'

export default {
  name: 'AddUser',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      countryCodes,
      userRoles,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm_password'], { force: true })
      }
      callback()
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add the new user!`,
            onOk: () => {
              this.$http
                .post('/api/user', {
                  first_name: values.first_name,
                  last_name: values.last_name,
                  email: values.email,
                  phone: values.phone,
                  role: values.role,
                  country_code: values.country_code,
                  password: values.password,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'User successfully added',
                    description: `${data.data.first_name} ${data.data.last_name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.form.resetFields()
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },

    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
    handleClear(e) {
      this.form.resetFields()
    },
  },
}
</script>
